





























































import { Component, Vue } from 'vue-property-decorator';
import { AxiosStatic } from 'axios';
import IReservation from "@/interfaces/IReservation";
import Calendar from '../components/Calendar.vue';
import IResource from "@/interfaces/IResource";
import ReservationListWidget from '@/components/ReservationListWidget.vue';
import OrganisationCalendarDaily from '@/components/OrganisationCalendarDaily.vue';

@Component({
	components: {
		OrganisationCalendarDaily,
		ReservationListWidget
	}
})
export default class Dashboard extends Vue {

	public reservations: IReservation[] | null = null;

	private $http!: AxiosStatic;


	get resources(): IResource[] {
		return this.$store.state.resources;
	}

	get hasMoreThanOneResource(): boolean {
		return this.resources.length > 1;
	}

	get build_commithash(): string {
		return (process.env.VUE_APP_BUILD_COMMITHASH || '').substring(0, 8);
	}

	get build_date(): string {
		return process.env.VUE_APP_BUILD_DATE || '';
	}

	get reservationsNext(): IReservation[] {
		if (this.reservations) {
			return this.reservations.slice(0,20);
		}
		return [];
	}

	get reservationLink(): string {
		if (this.resources.length > 1 && this.$store.state.organisation && this.$store.getters.singledayResources.length > 0) {
			return location.origin + '/org/' + this.$store.state.organisation.multicalendar_hash + '/' + (this.$store.state.organisation.name || 'reservation').replace(/[\W\s]+/g, '-').replace(/--/g, '-');
		} else if (this.resources.length === 1) {
			return location.origin + '/reservation/' + this.resources[0].reservationhash + '/' + this.resources[0].name.replace(/[\W\s]+/g, '-').replace(/--/g, '-');
		} else {
			return '';
		}
	}

	public async mounted(): Promise<void> {
		await this.loadReservations();
	}

	private async loadReservations(): Promise<void> {
		const response = await this.$http.get(`/private/reservation`);
		if (response.status !== 200) {
			throw new Error('could not load all reservations');
		}
		this.reservations = response.data;
	}
}
